// BE statuses for prompt change requests ("comments"). Finer-grained than the
// UI, which collapses them to Open/Resolved — see changeRequestHelpers.js.
export const REQUEST_STATUS = {
  OPEN: 'open',
  IN_REVIEW: 'in_review',
  RESOLVED: 'resolved',
  REJECTED: 'rejected',
}
